import React, { memo } from 'react'
import { Space, Tooltip, Typography } from 'antd'
import { TimeLineContentWrapper, TimeLineContentHeaderWrapper } from '../../../styles/styles'
import { ActivityInfo } from '../../../types/types'
import TimelineItemHeader from '../activity-timeline-item-header/activity-timeline-item-header'
import { TimelineItemProps } from '../activity-timeline-Item'
import { Avatar } from '../../../../../../ui/Avatar'

type ActivityTimelineInfoType = Omit<TimelineItemProps, 'data'>
interface ActivityTimelineInfoProps extends ActivityTimelineInfoType {
  className?: string
  data?: ActivityInfo
}

const { Text } = Typography

const ActivityTimelineInfo: React.FC<ActivityTimelineInfoProps> = memo(
  (props: ActivityTimelineInfoProps) => {
    const { date, data, user } = props
    return (
      <>
        <TimeLineContentWrapper>
          <TimeLineContentHeaderWrapper>
            <TimelineItemHeader date={date} title={'История'} />
            {user && (
              <Space>
                <Avatar src={user?.icon} alt={user?.name} />
                <Tooltip placement="top" title="Автор">
                  <span>{user?.name}</span>
                </Tooltip>
              </Space>
            )}
          </TimeLineContentHeaderWrapper>
          <Text style={{ whiteSpace: 'pre-line' }}>{data?.text}</Text>
        </TimeLineContentWrapper>
      </>
    )
  },
)

ActivityTimelineInfo.displayName = 'ActivityTimelineInfo'
export default ActivityTimelineInfo
